export const FilterTypeEnum = {
  Equal: 1,
  Include: 2,
};



// WEBPACK FOOTER //
// ./src/enuns/filterType.enum.js